import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../services/utils/utils.service';

@Component({
  selector: 'app-info-cocktail-modal',
  templateUrl: './info-cocktail-modal.component.html',
  styleUrls: ['./info-cocktail-modal.component.scss'],
})
export class InfoCocktailModalComponent implements OnInit {

  constructor(private _utilsService: UtilsService) {
  }

  ngOnInit() {
  }


}
